import {FormGroup, Label} from "reactstrap";
import {Validator} from "react-admin-base-bootstrap";
import React from "react";
import { FormattedMessage } from "react-intl";

export default function Field(props) {
    const { title, translate, type, children } = props;
    const isRequired = (type && type.indexOf("required") !== -1) || false;

    return <FormGroup>
        { (title||translate) && <Label><b>{title || <FormattedMessage id={translate || title} />}</b>{isRequired && <i className="fas fa-asterisk ms-1 text-danger field-required" />}</Label> }
        <Validator name={title} type={type}>
            { children[0] || children }
        </Validator>
        { children[1] || null }
    </FormGroup>
}
